// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-5efda68a]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.ui-setting-menu[data-v-5efda68a]{display:flex;height:52px;line-height:52px;padding-left:20px;position:relative}.ui-setting-menu.active[data-v-5efda68a]{background:#282944;color:#3d46f5}.ui-setting-menu .name[data-v-5efda68a]{flex:1}.ui-setting-menu .handle-box[data-v-5efda68a]{background-color:#151724;height:100%;position:absolute;right:0;top:0;width:35px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
